export interface AttachmentsResponse {
  items: {
    attachment_id: number;
    description: string;
    filename: string; // URL
    name: string;
    size: number;
    type: string;
    document_type: string;
    last_download: string;
    pim_id: string;
  }[];
  total_count: number;
}

/**
 * Fetches product attachments for a specific SKU.
 * If the product is configurable, the parent SKU must be provided as files are not available for child SKUs.
 *
 * Sends a GET request to the `/rest/en/V1/mit/axf/attachments/product/{sku}` endpoint.
 *
 * @param bearerToken A string for the authorization token, if provided.
 * @param sku An optional string representing the product SKU.
 * @returns A promise that resolves to an object containing attachment data if SKU and token are provided.
 * @throws An error if the fetch request fails or the response is not OK.
 */
export const fetchAttachments = async (
  bearerToken: string | null,
  sku?: string | null,
): Promise<AttachmentsResponse> => {
  try {
    if (sku && bearerToken) {
      const response = await fetch(
        `/rest/en/V1/mit/axf/attachments/product/${sku}`,
        {
          method: 'GET',
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data;
    }

    return {
      items: [],
      total_count: 0,
    };
  } catch (error) {
    throw error;
  }
};
